var map = {
	"./airports-sg/desktop.svg": "701d",
	"./airports-sg/mobile.svg": "4261",
	"./airports-sg/tablet.svg": "2db7",
	"./airports/desktop.svg": "9b8e",
	"./airports/mobile.svg": "a387",
	"./airports/tablet.svg": "1e75",
	"./icons/blue/icon_check-green.svg": "3a96",
	"./icons/blue/icon_vaccine-green.svg": "1248",
	"./icons/blue/icon_virus-green.svg": "0f10",
	"./icons/close-white.svg": "cb6c",
	"./icons/icon_check-green.svg": "f191",
	"./icons/icon_flight.svg": "3180",
	"./icons/icon_seat.svg": "0a51",
	"./icons/icon_vaccine-green.svg": "c565",
	"./icons/icon_vaccine-grey.svg": "42ba",
	"./icons/icon_vaccine-orange.svg": "1886",
	"./icons/icon_vaccine-red.svg": "582d",
	"./icons/icon_virus-green.svg": "6be6",
	"./icons/icon_virus-grey.svg": "432a",
	"./icons/icon_virus-orange.svg": "8dd6",
	"./icons/icon_virus-red.svg": "b191",
	"./icons/icon_x-green.svg": "fde7",
	"./icons/icon_x-grey.svg": "4dea",
	"./icons/icon_x-orange.svg": "a22f",
	"./icons/icon_x-red.svg": "f56b",
	"./key/key_hk_2019.svg": "c5da",
	"./key/key_hk_2020.svg": "3587",
	"./key/key_hk_2021.svg": "346a",
	"./key/key_kl_2019.svg": "6e2c",
	"./key/key_kl_2020.svg": "e94d",
	"./key/key_kl_2021.svg": "2b7c",
	"./key/key_lon_syd_2019.svg": "3002",
	"./key/key_lon_syd_2020.svg": "97bf",
	"./key/key_lon_syd_2021.svg": "9da9",
	"./sample-images/airplane_icon_s.png": "41cc",
	"./sample-images/airplane_icon_s_19.png": "65ed",
	"./sample-images/airplane_icon_s_20.png": "ea2f",
	"./sample-images/airplane_icon_s_21.png": "1daf",
	"./sample-images/airplane_icon_s_old.png": "a37c",
	"./sample-images/shadow_globe.png": "f7fa",
	"./scrolly-network/big.svg": "a3c1",
	"./scrolly-network/desktop.svg": "963c",
	"./scrolly-network/mobile.svg": "573d",
	"./scrolly-network/tablet.svg": "839a",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";